import styled from 'styled-components';
import { palette } from 'app_previous/styles/colors';

export interface StyledButtonPrimaryProps {
  weight?: 'normal' | 'bold';
  justify?: 'stretch' | 'center' | 'left' | 'right';
  color?: string;
  textColor?: string;
  padding?: string;
  width?: string;
}

export interface StyledCaptionSpanProps {
  captionJustify?: 'center' | 'left' | 'right';
  captionWeight?: '800' | 'bold' | 'normal' | 'light';
  captionColor?: 'white' | 'black';
}

export const StyledButtonPrimary = styled.button<StyledButtonPrimaryProps>`
  outline: none;
  cursor: pointer;
  background-color: ${({ color }) => color ?? palette.snowFlower};
  color: ${({ textColor }) => textColor ?? 'white'};
  border: none;
  width: ${({ width }) => width ?? 'auto'};
  padding: ${({ padding }) => padding ?? '.95em 2.5em'};
  border-radius: 4px;
  position: relative;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  font-family: Mulish;
  align-self: center;
  justify-self: ${({ justify }) => justify || 'stretch'};
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;

  &:hover {
    -webkit-filter: brightness(85%);
    filter: brightness(85%);
  }
`;

export const StyledCaptionSpan = styled.span<StyledCaptionSpanProps>`
  position: absolute;
  font-size: 11px;
  width: 100%;
  left: 0;
  bottom: -23px;
  color: ${palette.text};
  text-align: ${({ captionJustify }) => captionJustify || 'left'};
  font-weight: ${({ captionWeight }) => captionWeight || 'normal'};
  color: ${({ captionColor }) => captionColor || 'black'};
`;
